import React from "react";
import FadeInSection from "../../components/FadeInSection";
import FeatureCard from "../../components/CardFeature";
import IconParentsCorner from "../../../images/icons/parents-corner.svg";
import IconTeamManagement from "../../../images/icons/team-management.svg";
import IconCoachManagement from "../../../images/icons/coach-management.svg";
import IconBootXchange from "../../../images/icons/boot-xchange.svg";
import IconClubReports from "../../../images/icons/club-reports.svg";
import IconFixtureSanctioning from "../../../images/icons/fixture-sanctioning.svg";

const FeatureCards = () => {
    return(
        <>
        <FadeInSection>
        <div className="container">
            <h2>What We Do...</h2>
            <section className="row gap-2 mb-2" id="what-we-do">
            <div className="col-12-xs col-6-md">
                <div className="card"><h4>Club Management</h4></div>
                <FeatureCard>
                    <div className="feature-icon">
                        <img src={IconParentsCorner} alt="Parents Corner" />
                    </div>
                    <div className="feature-text">
                        <h5>Parents Corner</h5>
                        <p>Automate the flow of invoices and payments throughout the club. Allow your members to subscribe to their membership and ease administration.</p>
                    </div>
                </FeatureCard>
                <FeatureCard>
                    <div className="feature-icon">
                    <img src={IconBootXchange} alt="Parents Corner" />
                    </div>
                    <div className="feature-text">
                        <h5>Boot Xchange</h5>
                        <p>Streamline the exchange of football boots within the club. Enable members to swap boots effortlessly, making it simple to match sizes and reduce costs.</p>
                    </div>
                </FeatureCard>
                <FeatureCard>
                    <div className="feature-icon">
                    <img src={IconClubReports} alt="Club Reports" />
                    </div>
                    <div className="feature-text">
                        <h5>Club Reports</h5>
                        <p>Generate detailed club reports effortlessly with our software. Track performance, finances, and membership data to streamline club management.</p>
                    </div>
                </FeatureCard>
                
            </div>
            <div className="col-12-xs col-6-md">
                <div className="card"><h4>Sport Development</h4></div>
                <FeatureCard>
                    <div className="feature-icon">
                        <img src={IconTeamManagement} alt="Team Management" />
                    </div>
                    <div className="feature-text">
                        <h5>Team Management</h5>
                        <p>Organize your team's schedule and communication with ease. Empower coaches to manage players effectively and simplify team administration tasks.</p>
                    </div>
                </FeatureCard>
                <FeatureCard>
                    <div className="feature-icon">
                        <img src={IconCoachManagement} alt="Coach Management" />
                    </div>
                    <div className="feature-text">
                        <h5>Coach Management</h5>
                        <p>Organize schedules, track progress, and manage communications with ease. Simplify coaching tasks and enhance team performance seamlessly.</p>
                    </div>
                </FeatureCard>
                <FeatureCard>
                    <div className="feature-icon">
                        <img src={IconFixtureSanctioning} alt="Fixture Sanctioning" />
                    </div>
                    <div className="feature-text">
                        <h5>Fixture Sanctioning</h5>
                        <p>Streamline fixture sanctioning and scheduling across all your club's teams. Ensure compliance, reduce conflicts, and keep everyone informed effortlessly.</p>
                    </div>
                </FeatureCard>
            </div>
            </section>
            </div>
        </FadeInSection>
    </>
    )
}

export default FeatureCards;